// import { DashboardExerciseProgress, DashboardExerciseProgressRequest, DashboardExerciseResponse, DashboardExerciseSummary, DashboardHomeResponse, DashboardTimeframedRequest, HomeMuscleGroupRanking, MostTrainedExercise, Workout, WorkoutFrequency, WorkoutRequest } from '@api/entities';
import { DashboardExerciseProgress, DashboardExerciseProgressRequest, DashboardExerciseResponse, DashboardExerciseSummary, DashboardHomeResponse, DashboardMostTrainedGroup, DashboardSessionExerciseSummaryRequest, DashboardSessionSummary, DashboardTimeframedRequest, DashboardWorkoutExerciseSummaryRequest, HomeMuscleGroupRanking, MostTrainedExercise, Workout, WorkoutFrequency, WorkoutRequest } from 'src/api/entities';
import { DashboardApiClients, IDashboardApiClients } from './dashboard.api.client';

export interface IDashboardApiService {
  getWorkoutHeadStatus(request: WorkoutRequest): Promise<Array<Workout>>;
  getMostTrainedExercise(request: DashboardTimeframedRequest): Promise<Array<MostTrainedExercise>>;
  getAllTrainedExercise(request: DashboardTimeframedRequest): Promise<Array<MostTrainedExercise>>;
  getAllTrainedGroups(request: DashboardTimeframedRequest): Promise<Array<DashboardMostTrainedGroup>>;
  getMuscleGroupRanking(request: DashboardTimeframedRequest): Promise<Array<HomeMuscleGroupRanking>>;
  getWorkoutFrequency(request: DashboardTimeframedRequest): Promise<WorkoutFrequency>;
  getSessionSummary(sessionID: number): Promise<DashboardSessionSummary>;
  getWorkoutSummary(sessionID: number): Promise<DashboardSessionSummary>;
  getDashboardHome(request: DashboardTimeframedRequest): Promise<DashboardHomeResponse>;
  getDashboardExercise(request: DashboardExerciseProgressRequest): Promise<DashboardExerciseResponse>;
  getDashboardExerciseSummary(request: DashboardExerciseProgressRequest): Promise<DashboardExerciseSummary>;
  getDashboardExerciseProgress(request: DashboardExerciseProgressRequest): Promise<Array<DashboardExerciseProgress>>;
  getDashboardWorkoutExerciseSummary(request: DashboardWorkoutExerciseSummaryRequest): Promise<Array<DashboardExerciseSummary>>;
  getDashboardSessionExerciseSummary(request: DashboardSessionExerciseSummaryRequest): Promise<Array<DashboardExerciseSummary>>;
}

export class DashboardApiService implements IDashboardApiService {
    protected static instance: IDashboardApiService;
    protected api: IDashboardApiClients;

    protected constructor(basePath: string) {
        this.api = DashboardApiClients.getInstance(basePath);
    }
    static getInstance(basePath: string) {
        if (DashboardApiService.instance == null) {
            DashboardApiService.instance = new DashboardApiService(basePath);
        }
        return DashboardApiService.instance;
    }


    async getWorkoutHeadStatus(request: WorkoutRequest): Promise<Workout[]> {
      const response: Workout[] = (
        await this.api.dashboard.getWorkoutHeadStatus(request)
      ).data;
      return response;
    }
    async getSessionSummary(sessionID: number): Promise<DashboardSessionSummary> {
      const response: DashboardSessionSummary = (
        await this.api.dashboard.getSessionSummary(sessionID)
      ).data;
      return response;
    }
    async getWorkoutSummary(sessionID: number): Promise<DashboardSessionSummary> {
      const response: DashboardSessionSummary = (
        await this.api.dashboard.getWorkoutSummary(sessionID)
      ).data;
      return response;
    }
    async getMostTrainedExercise(request: DashboardTimeframedRequest): Promise<MostTrainedExercise[]> {
      const response: MostTrainedExercise[] = (
        await this.api.dashboard.getMostTrainedExercise(request)
      ).data;
      return response;
    }
    async getAllTrainedExercise(request: DashboardTimeframedRequest): Promise<MostTrainedExercise[]> {
      const response: MostTrainedExercise[] = (
        await this.api.dashboard.getAllTrainedExercise(request)
      ).data;
      return response;
    }
    async getAllTrainedGroups(request: DashboardTimeframedRequest): Promise<DashboardMostTrainedGroup[]> {
      const response: DashboardMostTrainedGroup[] = (
        await this.api.dashboard.getAllTrainedGroups(request)
      ).data;
      return response;
    }
    async getMuscleGroupRanking(request: DashboardTimeframedRequest): Promise<HomeMuscleGroupRanking[]> {
      const response: HomeMuscleGroupRanking[] = (
        await this.api.dashboard.getMuscleGroupRanking(request)
      ).data;
      return response;
    }
    async getWorkoutFrequency(request: DashboardTimeframedRequest): Promise<WorkoutFrequency> {
      const response: WorkoutFrequency = (
        await this.api.dashboard.getWorkoutFrequency(request)
      ).data;
      return response;
    }
    async getDashboardHome(request: DashboardTimeframedRequest): Promise<DashboardHomeResponse> {
      const response: DashboardHomeResponse = (
        await this.api.dashboard.getDashboardHome(request)
      ).data;
      return response;
    }
    async getDashboardExerciseSummary(request: DashboardTimeframedRequest): Promise<DashboardExerciseSummary> {
      const response: DashboardExerciseSummary = (
        await this.api.dashboard.getDashboardExerciseSummary(request)
      ).data;
      return response;
    }
    async getDashboardWorkoutExerciseSummary(request: DashboardWorkoutExerciseSummaryRequest): Promise<DashboardExerciseSummary[]> {
      const response: DashboardExerciseSummary[] = (
        await this.api.dashboard.getDashboardWorkoutExerciseSummary(request)
      ).data;
      return response;
    }
    async getDashboardSessionExerciseSummary(request: DashboardSessionExerciseSummaryRequest): Promise<DashboardExerciseSummary[]> {
      const response: DashboardExerciseSummary[] = (
        await this.api.dashboard.getDashboardSessionExerciseSummary(request)
      ).data;
      return response;
    }
    async getDashboardExerciseProgress(request: DashboardExerciseProgressRequest): Promise<DashboardExerciseProgress[]> {
      const response: DashboardExerciseProgress[] = (
        await this.api.dashboard.getDashboardExerciseProgress(request)
      ).data;
      return response;
    }
    async getDashboardExercise(request: DashboardExerciseProgressRequest): Promise<DashboardExerciseResponse> {
      const response: DashboardExerciseResponse = (
        await this.api.dashboard.getDashboardExercise(request)
      ).data;
      return response;
    }

}
